<template>
  <slot v-bind="{ onSuccess }"></slot>
</template>

<script>
import DocumentStore from '@/frontapp/mixins/DocumentStore'
import UpdateDocumentRevision from '@/frontapp/mixins/actions/UpdateDocumentRevision'

export default {
  mixins: [
    DocumentStore,
  ],
  methods: {
    async onSuccess (payload) {
      if (payload.$controls['approvalForm'].documentRev.id !== this.bcDocumentStore.documentRev) {
        await UpdateDocumentRevision(this.bcDocumentStore, payload.$controls['approvalForm'].documentRev.id, this.$router)
      } else {
        this.bcDocumentStore.document.approval = payload.$controls['approvalForm'].approval
      }
    }
  }
}
</script>
